import { SpaceHomeView } from 'shared';

import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import { ApiService } from '../../../services/index';
import { selectedCompanyStorage } from '../../../storage/company/selected-company.util';
import { SPACES_STALE_TIME_MS } from '../constants/spaces-query.const';

export const useSpacesHome = ({ enabled = true }: { enabled?: boolean } = {}) => {
  // Only keys the cache: the route takes the company from the session.
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isPending } = useAppQuery({
    queryKey: [QueryKey.GET_SPACES_HOME, companyId],
    queryFn: () =>
      ApiService.get<SpaceHomeView>({ endpoint: BackendRoute.SPACES, routePath: ['home'] }),
    enabled: enabled && !!companyId,
    staleTime: SPACES_STALE_TIME_MS,
  });

  return { home: data, isPending };
};
